<template>
  <div class="additional-questions" v-if="questions && questions.length">
    <div class="additional-question" :key="aq.id" v-for="aq in questions">
      <label class="additional-question-label input-top-label">
        {{ aq.question.question }}
      </label>
      <div
        v-html="aq.question.questionInstructions"
        v-if="
          aq.question.questionInstructions &&
            aq.question.questionInstructions.length
        "
      ></div>
      <myswitch :value="aq.question.type">
        <template #Number>
          <input
            :class="{
              error: !aq.isValid && aq.hasValueChanged,
              'additional-question-answer': true,
            }"
            type="number"
            maxlength="1000"
            @change="onChange($event, aq)"
            :value="aq.value"
            :disabled="disabled"
          />
        </template>
        <template #Text>
          <input
            type="text"
            maxlength="1000"
            :class="{
              error: !aq.isValid && aq.hasValueChanged,
              'additional-question-answer': true,
            }"
            @change="onChange($event, aq)"
            :value="aq.value"
            :disabled="disabled"
          />
        </template>
        <template #Select>
          <select
            :class="{
              error: !aq.isValid && aq.hasValueChanged,
              'additional-question-answer': true,
            }"
            @change="onChange($event, aq)"
            :disabled="disabled"
          >
            <option></option>
            <option
              v-for="option in aq.question.data.items"
              :key="option.value"
              :value="option.value"
              :selected="aq.value === option.value"
              >{{ option.name }}</option
            >
          </select>
        </template>
        <template #File>
          <Upload
            :files="aq.files || []"
            :class="{
              error: !aq.isValid && aq.hasValueChanged,
              'additional-question-answer': true,
            }"
            @change="(files) => onFilesChange(files, aq)"
            :disabled="disabled"
          ></Upload>
        </template>
      </myswitch>
    </div>
  </div>
</template>

<script>
import myswitch from "@/vueext/myswitch";
import Upload from "./Upload.vue";
import utils from "@/services/utils";
import Vue from "vue";

export default {
  name: "ServiceAdditionalQuestions",
  props: {
    additionalQuestions: Array,
    givenAnswers: Array,
    disabled: Boolean,
  },
  components: {
    myswitch,
    Upload,
  },
  watch: {
    additionalQuestions(newVal) {
      this.setQuestions(newVal);
    },
    givenAnswers() {
      this.setQuestions(this.additionalQuestions);
    },
  },
  methods: {
    validateAll() {
      this.questions.forEach((q) => (q.hasValueChanged = true));
      const allValid = Vue.nextTick().then(() => {
        return this.questions.every((f) => f.isValid);
      });
      return allValid;
    },
    onFilesChange(files, aq) {
      const fakeEvent = {
        target: {
          value: files,
        },
      };
      this.onChange(fakeEvent, aq);
    },
    onChange(event, aq) {
      const currentItem = this.questions.find((item) => {
        return aq.question.id === item.question.id;
      });
      currentItem.groupQuestions.forEach((loopItem) => {
        const item = this.questions.find((f) => f.question.id === loopItem.id);
        if (!item) {
          return;
        }
        item.value = event.target.value;
        item.displayValue = item.value;
        item.hasValueChanged = true;
        item.serviceId = loopItem.serviceId;
        switch (aq.question.type) {
          case "Number":
            if (item.question.required) {
              item.isValid = !utils.isBlank(item.value) && isFinite(item.value);
            } else {
              item.isValid = !utils.isBlank(item.value)
                ? isFinite(item.value)
                : true;
            }
            break;
          case "Text":
            if (item.question.required) {
              item.isValid = !utils.isBlank(item.value);
            } else {
              item.isValid = true;
            }
            break;
          case "Select":
            var selectItem = item.question.data.items.find((i) => {
              return i.value === aq.value;
            });
            if (selectItem) {
              item.displayValue = selectItem.name;
            }
            if (item.question.required) {
              item.isValid = item.value && item.value.length > 0;
            } else {
              item.isValid = true;
            }
            break;
          case "File":
            item.files = item.value;
            var value = item.value.map((f) => f.reference).join(";");
            var displayValue = item.value.map((f) => f.fileName).join(", ");
            item.value = value;
            item.displayValue = displayValue;
            if (item.question.required) {
              item.isValid = item.value.length > 0;
            } else {
              item.isValid = true;
            }
        }
      });

      this.$emit("change", this.questions);
    },
    getGroupKey(additionalQuestion) {
      return `${additionalQuestion.question}|${additionalQuestion.type}`;
    },
    getGrouped(additionalQuestions) {
      const groups = additionalQuestions?.reduce((acc, curr) => {
        const groupKey = this.getGroupKey(curr);
        if (acc.has(groupKey)) {
          acc.set(groupKey, [...acc.get(groupKey), curr]);
        } else {
          acc.set(groupKey, [curr]);
        }
        return acc;
      }, new Map());
      return groups;
    },
    setQuestions(additionalQuestions) {
      const vm = this;
      const groups = this.getGrouped(additionalQuestions);
      const questions = [...groups]?.map((questionGroup) => {
        const q = questionGroup.at(1)[0];
        var answer = vm.givenAnswers?.find((f) => f.question.id === q.id);
        var isValid = false;
        if (q.required) {
          if (answer && answer.value && answer.value.length) {
            isValid = true;
          } else {
            isValid = false;
          }
        } else {
          isValid = true;
        }

        return {
          value: answer?.value || undefined,
          displayValue: answer?.displayValue || undefined,
          files: answer?.files || undefined,
          question: q,
          isValid: isValid,
          hasValueChanged: answer ? answer.hasValueChanged : false,
          groupQuestions: questionGroup.at(1)
        };
      });
      this.questions = questions || [];
      this.$emit(
        "valid",
        this.questions.every((f) => f.isValid)
      );
    },
  },

  created() {
    this.setQuestions(this.additionalQuestions);
    this.$emit("change", this.questions);
  },
  data() {
    return {
      questions: [],
    };
  },
};
</script>
<style scoped>
.additional-questions {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.5rem 2rem -0.5rem;
}
.additional-question {
  flex: 1 1 50%;
  padding: 0 0.5rem;
  max-width: 50%;
}
@media screen and (max-width: 767px) {
  .additional-question {
    max-width: 100%;
    flex: 1 1 50%;
  }
}
.additional-question-answer,
.additional-question-label {
  display: block;
  width: 100%;

  font-weight: 500;
}
</style>
